var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"z-50"},[_vm._l((_vm.data),function(dat){return [_c('LegalReminderComp',{key:dat.id,attrs:{"legal":dat,"members":_vm.columns},on:{"closed":_vm.closed}})]}),_vm._l((_vm.follup),function(dat){return [_c('LegalFollowUpAcknowledgeComp',{key:dat.id,attrs:{"legal":dat},on:{"closed":_vm.closedFollowUp}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }